import React, { useState, useEffect, useRef } from "react";
import { Button, Form, Table, Nav, Row, Col } from "react-bootstrap";

import { ToastContainer, toast } from "react-toastify";

import MemberPaypalSetting from "./MemberPaypalSetting";
// import MemberPaypalSetting from "./MemberPaypalSetting";

const SettingsManagement = () => {
    const [activeTab, setActiveTab] = useState("paypal-list");

    return (
        <>
            <ToastContainer position="top-center" />

            <div className="container-fluid">
                <Row>
                    <h4>Settings</h4>
                    <Col md={12} className="mb-3">
                        {/* Sidebar Menu */}
                        <div className="nav-tabs d-flex justify-content-start align-items-center ">
                            <Nav variant="pills" className=" custom-pills">
                                {/* <Nav.Link active={activeTab === "article-list"} onClick={() => setActiveTab("article-list")}>
                                    General Settings
                                </Nav.Link> */}
                                <Nav.Link active={activeTab === "paypal-list"} onClick={() => setActiveTab("paypal-list")}>
                                    PayPal Settings
                                </Nav.Link>
                                {/* Add more menu items here if needed */}
                            </Nav>
                        </div>
                    </Col>
                    <Col md={9}>
                        {/* Main Content */}
                        {/* <MemberPaypalSetting activeTab={activeTab} setActiveTab={setActiveTab} /> */}
                        <MemberPaypalSetting activeTab={activeTab} setActiveTab={setActiveTab} />
                    </Col>
                </Row>
                <style jsx>{`
                    .custom-pills .nav-link.active {
                        background-color: black;
                        color: #000 !important;
                        border-radius: 0px !important;
                        border: 0px !important;
                        border-bottom: 1px solid #000 !important;
                    }

                    .custom-pills .nav-link {
                        color: #343a40;
                        border: 0px !important;
                    }

                    .custom-pills .nav-link:hover {
                        background-color: transparent;
                        color: #000 !important;
                    }
                `}</style>
            </div>
        </>
    );
};

export default SettingsManagement;
